var _rect, _g, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercardFormIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 20.6667,
    rx: 4,
    fill: "#282828"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.00391,
    y: 2.06667,
    width: 25.0002,
    height: 16.5333,
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.207,
    y: 4.94708,
    width: 6.59396,
    height: 10.7725,
    fill: "#F26122"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9169 10.3333C12.906 8.23666 13.8583 6.25106 15.5002 4.94709C12.691 2.73788 8.65565 3.05868 6.23077 5.68399C3.80589 8.30929 3.80589 12.3574 6.23077 14.9827C8.65565 17.608 12.691 17.9288 15.5002 15.7196C13.8583 14.4156 12.906 12.43 12.9169 10.3333Z",
    fill: "#EA1D25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9241 14.3569V14.5765H25.8853V14.3569H25.7949V14.3117H26.021V14.3569H25.9241ZM26.3636 14.3117V14.5765H26.3183V14.3763L26.2473 14.5506H26.1956L26.1181 14.3763V14.5765H26.0729V14.3117H26.1375L26.2215 14.499L26.299 14.3117H26.3636Z",
    fill: "#F69E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5825 10.3333C26.5808 12.955 25.0834 15.3459 22.7255 16.4919C20.3676 17.6379 17.5624 17.338 15.5 15.7196C18.4709 13.3803 18.9853 9.07673 16.6496 6.10313C16.3148 5.67253 15.9287 5.28432 15.5 4.94708C17.5624 3.32862 20.3676 3.02879 22.7255 4.17478C25.0834 5.32076 26.5808 7.71167 26.5825 10.3333Z",
    fill: "#F69E1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardFormIcon);
export default __webpack_public_path__ + "static/media/mastercardFormIcon.672603281c4060324ad10287df4cba40.svg";
export { ForwardRef as ReactComponent };